import type { ArmyPaint } from "../../../lib/core/ArmyPainter/ArmyPaint.type"
import { colorNamesPool, type ColorNamePair } from "../../../lib/core/player/colorNamesPool"
import randomElement from "../../../lib/core/rng/randomElement"
import tmpRngWith from "../../../lib/core/rng/tmpRngWith"
import type { SgColumnID } from "../../../lib/core/SgColumnID.type"

export default function createRandomArmyPaint(id: SgColumnID): ArmyPaint {

  const colorNamePair : ColorNamePair = randomElement(colorNamesPool, tmpRngWith(id))

  return {
    id,
    ...colorNamePair,
    dname: null,
  }
}